import React from 'react'
import { isFunction, isPlainObject } from 'lodash'
import { LocalizedString } from '~/models'

export function childrenOfType<P>(children: React.ReactNode, ...types: React.ComponentType<P>[]): Array<React.ReactElement<P>> {
  const allChildren = React.Children.toArray(children) as Array<React.ReactElement<any>>

  return allChildren.filter(child => {
    if (!React.isValidElement(child)) { return false }
    return types.includes((child as any).type)
  })
}

export function childrenNotOfType<P>(children: React.ReactNode, types: React.ComponentType<P>[]): Array<React.ReactElement<P>> {
  const allChildren = React.Children.toArray(children) as Array<React.ReactElement<any>>

  return allChildren.filter(child => {
    if (!React.isValidElement(child)) { return true }
    return !types.includes((child as any).type)
  })
}

export function isReactText(children: React.ReactNode): children is React.ReactText | LocalizedString {
  if (typeof children === 'string') { return true }
  if (typeof children === 'number') { return true }
  if (isPlainObject(children) && !React.isValidElement(children)) { return true } // Could be localized string.
  return false
}

export function isReactComponent<P>(arg: any): arg is React.ComponentType<P> {
  if (isPlainObject(arg) && arg.$$typeof != null) {
    return true
  }
  if (isFunction(arg)) {
    return true
  }

  return false
}